import React, { useEffect } from 'react';
import './BotonCerrarSesion.css';

const BotonCerrarSesion = (props) => {
    const { servicio, setCargando, marca, servicioFirebase } = props;
    useEffect(() => {
    }, []);
    return (
        <div onClick={() => { 
            if (marca !== process.env.REACT_APP_MARCA_VW) {
                servicioFirebase.registrarEventoPersonalizadoAnalitica("action-cerrar-sesion", {marca: marca, descripcion: "Cierre de Sesion"});
            }            
            setCargando(true); servicio.cerrarSesion(marca==="seat"?process.env.REACT_APP_LOGOUT_REDIRECT_SEAT:(marca==="audi"?process.env.REACT_APP_LOGOUT_REDIRECT_AUDI:process.env.REACT_APP_LOGOUT_REDIRECT)).then(data => { setCargando(false); window.location = data }).catch(err => { setCargando(false); console.log(err); }) 
                        }}
            className="boton-cerrar-sesion">Cerrar sesión</div>
    )
}
export default BotonCerrarSesion;